/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './Message';

/**
 * 
 * @export
 * @interface SendMessageResponse
 */
export interface SendMessageResponse {
    /**
     * 
     * @type {Array<Message>}
     * @memberof SendMessageResponse
     */
    messages: Array<Message>;
    /**
     * 
     * @type {number}
     * @memberof SendMessageResponse
     */
    elapsedTime: number;
}

/**
 * Check if a given object implements the SendMessageResponse interface.
 */
export function instanceOfSendMessageResponse(value: object): value is SendMessageResponse {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('elapsedTime' in value) || value['elapsedTime'] === undefined) return false;
    return true;
}

export function SendMessageResponseFromJSON(json: any): SendMessageResponse {
    return SendMessageResponseFromJSONTyped(json, false);
}

export function SendMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'elapsedTime': json['elapsedTime'],
    };
}

export function SendMessageResponseToJSON(json: any): SendMessageResponse {
    return SendMessageResponseToJSONTyped(json, false);
}

export function SendMessageResponseToJSONTyped(value?: SendMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(MessageToJSON)),
        'elapsedTime': value['elapsedTime'],
    };
}

